import type {
  Identified,
  TenantOwned,
  VersionedEntity
} from "../shared/kernel/entity.js";
import type { UtcDateTime } from "../shared/kernel/date-time.js";
import type { DefinitionId, UserId } from "../shared/kernel/identifiers.js";

export enum StudioArtifactType {
  Module = "MODULE",
  Form = "FORM",
  Checklist = "CHECKLIST",
  Report = "REPORT",
  Catalog = "CATALOG",
  Rule = "RULE",
  Formula = "FORMULA",
  Workflow = "WORKFLOW"
}

export enum StudioScope {
  Global = "GLOBAL",
  Client = "CLIENT"
}

export interface StudioDefinition
  extends Identified<DefinitionId>, TenantOwned, VersionedEntity {
  readonly artifactType: StudioArtifactType;
  readonly code: string;
  readonly name: string;
  readonly description: string;
  readonly scope: StudioScope;
  readonly extensionOnly: true;
  readonly createdBy: UserId;
  readonly updatedBy: UserId;
  readonly deletedAt: UtcDateTime | null;
}
